<a href="{{ config.apiUrl }}/excelSample/sampleOriginal.xlsx">{{
  anchorText
}}</a>
